<div class="file-upload-container">
  <div class="center flex image-content">
    @if (fileInput) {
      <img class="image" [src]="getFileUri()" />
    }
    @if (!fileInput) {
      <mat-icon class="input-icon">
        {{ icon }}
      </mat-icon>
    }
  </div>

  @if (fileInput) {
    <div class="selected-file">
      <a href="#" (click)="downloadFile($event)">
        {{ shortenFileName(fileInput.fileName) }}
      </a>
      <p>({{ fileInput.sizeInBytes! | fileSize }})</p>
    </div>
  }

  @if (!viewOnly && !fileInput) {
    <div class="buttons">
      <input
        #file
        mat-raised-button
        type="file"
        (click)="file.value = ''"
        value=""
        accept="{{ validFileExtensions }}"
        (change)="addFile($event)"
        hidden
      />
      <button type="button" mat-raised-button value="Choose File" class="full-width-button" (click)="file.click()">
        {{ 'ACTIONS.UPLOAD' | translate }}
      </button>
    </div>
  }

  <div class="icao-button-container">
    @if (!viewOnly && icaoValidation && fileInput && icaoResult && icaoResult.score) {
      @if (icaoResult.score < ICAO_SCORE_QUALITY_THRESHOLD) {
        <p>{{ 'ATTACHMENT_ERROR.LOW_ICAO_SCORE' | translate }}</p>
      }

      <button
        color="primary"
        mat-raised-button
        type="button"
        class="full-width-button"
        (click)="openPhotoResultsDialog()"
      >
        {{ 'ICAO.SEE_RESULT' | translate }}
      </button>
    }
  </div>

  @if (!viewOnly && fileInput) {
    <div class="remove-button-container">
      <button mat-raised-button color="warn" type="button" class="full-width-button" (click)="removeFile()">
        <mat-icon>delete</mat-icon>
        {{ 'ACTIONS.REMOVE' | translate }}
      </button>
    </div>
  }

  @if (!viewOnly && description && !fileInput) {
    <div>
      <label>{{ description }}</label>
    </div>
  }
</div>
